const REVEAL_WAIT = 4000;

class ByobOfferCards extends HTMLElement {
  constructor() {
    super();
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  connectedCallback() {
    this.pricePrefix = this.dataset.prefix;
    this.referencePrice = Number(this.dataset.referencePrice) || 0;
    this.cards = {
      low: this.querySelector('[data-offer="low"]'),
      high: this.querySelector('[data-offer="high"]'),
    };

    this.revealTimer = window.setTimeout(() => this.reveal(), REVEAL_WAIT);

    document.addEventListener('byob:update', this.handleUpdate);
    document.dispatchEvent(new CustomEvent('byob:request-state'));
  }

  disconnectedCallback() {
    document.removeEventListener('byob:update', this.handleUpdate);
    window.clearTimeout(this.revealTimer);
  }

  reveal() {
    window.clearTimeout(this.revealTimer);
    this.removeAttribute('data-pending');
  }

  fillTokens(template, tokens) {
    return Object.entries(tokens).reduce(
      (text, [token, value]) => text.replaceAll(`[${token}]`, value),
      template ?? ''
    );
  }

  formatNumber(amount) {
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      maximumFractionDigits: 0,
    }).format(amount);
  }

  renderCard(card, count, price) {
    if (!card || !count || price == null) return;

    const { pickText, perText, saveText } = this.dataset;
    const perProduct = Math.floor(price / count);
    const reference = count * this.referencePrice;
    const saving = reference - price;

    card.querySelector('[data-offer-pick]').textContent = this.fillTokens(pickText, { count });
    card.querySelector('[data-offer-price]').textContent = `${this.pricePrefix} ${this.formatNumber(price)}`;
    card.querySelector('[data-offer-per]').textContent = this.fillTokens(perText, {
      prefix: this.pricePrefix,
      price: this.formatNumber(perProduct),
    });

    const save = card.querySelector('[data-offer-save]');
    const showSaving = saving > 0;
    save.hidden = !showSaving;
    if (showSaving) {
      save.textContent = this.fillTokens(saveText, {
        prefix: this.pricePrefix,
        amount: this.formatNumber(saving),
        percent: Math.round((saving / reference) * 100),
      });
    }
  }

  handleUpdate(event) {
    const { tiers } = event.detail ?? {};
    if (!tiers) return;

    this.renderCard(this.cards.low, tiers.low, tiers.priceLow);
    this.renderCard(this.cards.high, tiers.high, tiers.priceHigh);
    this.reveal();
  }
}

if (!customElements.get('byob-offer-cards')) {
  customElements.define('byob-offer-cards', ByobOfferCards);
}
